// extracted by mini-css-extract-plugin
export default {"DateAtt":"Invoice_DateAtt__iFgbB","DateWrapperClass":"Invoice_DateWrapperClass__c5sBH"};